
<div class="headerRightSec">

  @if (showProductsMenu && isSingleSignonClient) {
    <ng-container>
      <div class="reliabilityPlatformSec">
          <a class="btn btn-primary" data-toggle="collapse" (click)="toggleProducts()" data-target="#hrpCollapse" aria-expanded="false" aria-controls="hrpCollapse">
            <span class="producthub" data-toggle="tooltip" data-placement="right" title="Press Ganey Product Hub">Available Products</span>
          </a>

          @if (showPgProducts) {
            <div class="collapse pgProducts" id="hrpCollapse">
                <div class="pgTitle">
                  <h5>{{ singleSignonTitle }}</h5>
                  <a class="btn" (click)="toggleProducts()" data-toggle="collapse" href="#hrpCollapse"><i class="fa-solid fa-xmark"></i></a>
                </div>

                <!-- Active registrations -->
                <ng-container *ngFor="let reg of userRegistrations">
                  <ng-container *ngIf="reg.isUserRegistered === true">
                    <div class="pgProductCard cardDone">
                      <a data-toggle="collapse" href="#hrpCollapse" (click)="switchProducts(reg.idpName)">
                        <div class="cardTitle">
                            <h4 [innerHTML]="getTitle(reg)"></h4>
                            <div class="greenCheck">
                                <i class="fa-solid fa-circle-check"></i>
                            </div>
                        </div>
                        <p>{{ reg.IdpDescription }}</p>
                      </a>
                    </div>
                  </ng-container>

                  <!-- Inactive registrations -->
                  <ng-container *ngIf="reg.isUserRegistered !== true">
                    <div class="pgProductCard cardPending">
                      <a data-toggle="collapse" href="#hrpCollapse" (click)="switchProducts(reg.idpName)">
                        <div class="cardTitle">
                            <h4 [innerHTML]="getTitle(reg)"></h4>
                            <div class="greyInfo">
                                <i class="fa-solid fa-circle-info"></i>
                            </div>
                        </div>
                        <p>{{ reg.IdpDescription }}</p>
                      </a>
                    </div>
                  </ng-container>

                </ng-container>

            </div>
          }

      </div>
    </ng-container>
  }

  <div *ngIf="enableNotifications" class="notificationSec">
    <a class="btn">
      <i class="fa-solid fa-bell-slash"></i>
    </a>
  </div>
  <div *ngIf="isUserLoggedIn" class="userInfoSec">
      <a class="btn">
          <img id="user-icon" class="img-fluid" src="assets/images/person.png" alt="user logo">
          <span>{{userEmail}}</span>
      </a>
  </div>

</div>

